var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 26C20.1796 26 26 20.1796 26 13C26 5.82045 20.1796 5.08839e-07 13 1.1365e-06C5.82044 1.76415e-06 -1.76415e-06 5.82045 -1.1365e-06 13C-5.08839e-07 20.1796 5.82045 26 13 26ZM13 2.16668C18.9829 2.16668 23.8333 7.01706 23.8333 13C23.8333 18.9829 18.9829 23.8333 13 23.8333C7.01706 23.8333 2.16668 18.9829 2.16668 13C2.16668 7.01706 7.01705 2.16668 13 2.16668Z",
    fill: "#B82428"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4006 19.1827C14.8237 19.6058 15.5096 19.6058 15.9327 19.1827C16.3558 18.7596 16.3558 18.0737 15.9327 17.6506L11.2821 13L15.9327 8.34934C16.3558 7.92628 16.3558 7.24033 15.9327 6.81727C15.5096 6.39421 14.8237 6.39421 14.4006 6.81727L8.98395 12.234C8.56089 12.657 8.56089 13.343 8.98395 13.766L14.4006 19.1827Z",
    fill: "#B82428"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonBack);
export default __webpack_public_path__ + "static/media/buttonBack.93342d4fc7b1377e17419a316f5541b9.svg";
export { ForwardRef as ReactComponent };